import { HOME_PATH } from '../../constants'

export const getContributionUserURL = (groupId: string) => {
  return `${HOME_PATH}/${groupId}/contribute`
}

export const getContributeGuestURL = (groupId: string) => {
  return `${HOME_PATH}/${groupId}/contribute-guest`
}
